import React, { useEffect, useState } from "react";
import { LabelPadrao, LoadingContainerPadrao, ModalPadrao } from "../../components/Base";
import { BtnGravar, BtnSair } from "../../components/Buttons";
import { fetch } from "../../actions";
import { useFetch } from "../../components/Hooks/Conexao";
import culture from "../../Utils/Culture";
import { connect } from "react-redux";
import { useMemo } from "react";
import TabelaPadrao from "../../components/TabelaPadrao";

function ModalVale({ onOk, onCancel, visible, edicao, clienteId, ...props }) {
  const [dados, listar, loading] = useFetch(() => props.fetch().post(`contas/getvale/${clienteId}`));
  const [marcados, setMarcados] = useState([]);
  const hasTituloEmAberto = dados?.hasTitulosEmAberto;
  const titulos = dados?.titulos || [];
  const total = useMemo(() => (hasTituloEmAberto ? titulos : marcados.map(x => titulos.find(s => s.id == x)))?.reduce((a, b) => a + b?.valor, 0), [dados, marcados]);


  useEffect(() => {
    if (!marcados.length && visible)
      listar();

    if (visible && !!edicao?.length)
      setMarcados(edicao.map(x => x.id));

  }, [visible]);

  const columns = [
    { Header: "Número", accessor: "numero" },
    { Header: "Vencimento", accessor: "venc", tipo: "dt", },
    { Header: "Valor", accessor: "valor", tipo: "rs", Footer: `R$ ${culture.format(total)}` }
  ];

  return <ModalPadrao title={(hasTituloEmAberto && titulos.length) ? "Não é possível usar este pagamento no momento" : "Selecione os vales"} visible={visible} footer={<>
    {!hasTituloEmAberto && <BtnGravar txt="Confirmar" onClick={() => { onOk(marcados.map(x => titulos.find(s => s?.id == x)).filter(x => !!x?.id), total); setMarcados([]); }} disabled={!marcados.length} />}
    <BtnSair onClick={onCancel} />
  </>} closable={false}>
    <LoadingContainerPadrao loading={loading} style={{ minHeight: 200 }}>

      {!!titulos?.length ? <>
        {hasTituloEmAberto && <LabelPadrao noMargin>O cliente possuí estes títulos em aberto</LabelPadrao>}
        <TabelaPadrao columns={columns} data={titulos} marcados={hasTituloEmAberto ? null : marcados} setMarcados={hasTituloEmAberto ? null : setMarcados} />
      </>
        : (loading) ? <></> : <h3 style={{ textAlign: "center" }}>Este cliente não possuí vales.</h3>}
    </LoadingContainerPadrao>
  </ModalPadrao>;
}

export default connect(null, { fetch })(ModalVale);